module.exports = __webpack_public_path__ + "img/other_pay_credit_card2.a4ae5a71.svg";